// Enums for the session-detail "Évaluations" tab (Phase 2). Chaud/froid reuses SurveyTypeEnum
// (DIRECT/DELAYED) from satisfaction-surveys.enums. Wired to FormsApi (session-forms tracking + create/update/resend/delete).

// Survey-level status shown on a session's enquête.
export enum SessionSurveyStatusEnum {
  SCHEDULED = "scheduled", // Programmée
  SENT = "sent", // Envoyée
}

// Per-participant status inside a survey's table.
export enum SessionSurveyParticipantStatusEnum {
  SCHEDULED = "scheduled", // Programmé
  SENT = "sent", // Envoyé
  COMPLETED = "completed", // Complété (a répondu)
}

// "Nouvelle enquête" modal — send mode.
export enum SessionSurveySendModeEnum {
  NOW = "now", // Envoyer maintenant
  SCHEDULED = "scheduled", // Programmer l'envoi
}

// "Nouvelle enquête" modal — recipients.
export enum SessionSurveyRecipientEnum {
  PARTICIPANTS = "participants",
  MANAGERS = "managers",
}

// "Nouvelle enquête" modal — relative-offset scheduler (Programmer l'envoi).
// PRD AC-SESSEVAL-03.2: units are heure(s)/jour(s) only.
export enum SessionSurveyOffsetUnitEnum {
  HOUR = "hour", // heure(s)
  DAY = "day", // jour(s)
}

export enum SessionSurveyOffsetDirectionEnum {
  BEFORE = "before", // avant
  AFTER = "after", // après
}

export enum SessionSurveyOffsetAnchorEnum {
  SESSION_START = "session_start", // le début de la session
  SESSION_END = "session_end", // la fin de la session
}

// Which screen the public /survey/[token] response page shows (Phase 3).
export enum SurveyResponsePageStateEnum {
  LOADING = "loading",
  NOT_FOUND = "not_found", // unknown/invalid token
  ALREADY_SUBMITTED = "already_submitted", // participant already Complété — no re-edit (AC-LEARN-04.3)
  WIZARD = "wizard", // answering the questionnaire
  DONE = "done", // thank-you screen after submit
}
